module.exports = __webpack_public_path__ + "media/images/guide-thumb-6-8e6c1aa21250928cc29e05732ef9765b.png";